export enum ENamePartners {
  N1 = 'N1',
  Bankiru = 'banki.ru',
}
